module.exports = __webpack_public_path__ + "static/media/boy-11.e7d352b0.svg";